import styled from '@emotion/styled'
import React from 'react'
import { formatTimestamp } from '../../../../utils/time'
import { degreesToDirection } from '../../../../utils/plotting'
import capitalize from 'lodash/capitalize'
import { showDecimalAsPercentage } from './index'
import { Vehicle, VehicleLocation, Agencies, VehicleType, DeviceType } from 'server'

export const StyledSpan = styled.span`
  color: black;
`

export const StyledB = styled.b`
  color: black;
`

export const renderInfoWindowItem = (
  key: string,
  value: string | number,
  formatter = (value: string | number) => value
) => {
  return !value ? null : (
    <>
      <StyledSpan>
        {key}: <StyledB>{formatter(value)}</StyledB>
      </StyledSpan>
      <br />
    </>
  )
}

export const renderInfoWindowDivider = () => {
  return <div style={{ borderBottom: '1px solid lightgrey', marginBottom: '6px', marginTop: '6px' }} />
}

export const renderInfoWindowTitle = (title: React.ReactNode | React.ReactNode[]) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: '1px solid lightgrey',
        padding: '12px 0 6px 0',
        marginBottom: '6px'
      }}
    >
      {title}
    </div>
  )
}

/**
 * Render the vehicle info window
 * @param vehicle
 * @param vehicleLocation
 * @param agency
 * @param vehicleType
 * @param deviceType
 */
export const renderVehicleInfoWindow = (
  vehicle: Vehicle,
  vehicleLocation: VehicleLocation,
  agency: Agencies,
  vehicleType: VehicleType,
  deviceType: DeviceType
) => {
  return (
    <div>
      {renderInfoWindowTitle(<StyledB>{vehicle?.name}</StyledB>)}
      {renderInfoWindowItem('Agency', agency?.name)}
      {renderInfoWindowItem('Update Time', vehicleLocation?.update_received, (value: string | number) =>
        typeof value === 'string' ? formatTimestamp(value, 'LLL') : value
      )}
      {renderInfoWindowItem('Vehicle Type', vehicleType?.name)}
      {renderInfoWindowItem('Device Type', deviceType?.name)}
      {renderInfoWindowItem('Heading', vehicleLocation?.heading, (value: string | number) =>
        degreesToDirection(value)
      )}
      {renderInfoWindowItem(
        'Speed',
        vehicleLocation?.speed,
        (value: string | number) => `${Number(value || 0).toFixed(0)} MPH`
      )}
      {renderInfoWindowItem('Battery Voltage', vehicleLocation?.battery_voltage, (value: string | number) =>
        Number(value).toFixed(0)
      )}
      {renderInfoWindowItem('Battery Charging', vehicleLocation?.battery_charging, (value: string | number) =>
        typeof value === 'string' ? capitalize(value) : value
      )}
      {renderInfoWindowItem('Battery Level', vehicleLocation?.battery_level, (value: string | number) =>
        showDecimalAsPercentage(Number(value))
      )}
    </div>
  )
}
